<template>
	<div class="task-log-info-details">
		<div class="flex-space-between--center">
			<div class="flex-centerize">
				<SIcon name="flow-type-cloud" width="15" />
				<div class="task-title pl-3">{{ taskInfo.workflow.workflow_title }}</div>
			</div>
			<v-tooltip bottom>
				<template v-slot:activator="{ on, attrs }">
					<div v-bind="attrs" v-on="on" class="task-id text-overflow-ellipsis">Task ID: {{ taskInfo.id }}</div>
				</template>
				{{ taskInfo.id }}
			</v-tooltip>
		</div>
		<div class="meta-info mt-2 mb-3">
			<span class="emphasize">Triggered at </span>{{ taskInfo.created | formatDate }}
			<span class="emphasize ml-1" v-if="triggeringUserText"> By {{ triggeringUserText }}</span>
		</div>
		<div class="flex-space-between--center">
			<div class="display-flex">
				<StatusIndicator :status="taskInfo.status" />
				<div v-if="isDataExpired" class="expired-indicator ml-2">Data expired</div>
			</div>
			<div class="det">
				<a v-if="editFlowUrl && showEditFeatureLink" class="primary-link-style" :href="editFlowUrl">Edit feature</a>
				<router-link v-if="toInputLogs" class="primary-link-style ml-4" :to="toInputLogs">See input logs</router-link>
			</div>
		</div>

		<div class="horizontal-divider mt-3 mb-4" />
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { editFlowLink } from '@/store/modules/workflows/getters';
import { getTriggeringUserText } from './TaskLogService';
import StatusIndicator from './common/StatusIndicator';

export default {
	name: 'TaskLogInfoDetails',
	components: {
		StatusIndicator,
	},
	props: {
		taskInfo: { type: Object },
		showEditFeatureLink: { type: Boolean, default: true },
	},
	computed: {
		...mapGetters([editFlowLink.fullPath]),
		triggeringUserText() {
			return getTriggeringUserText(this.taskInfo.user);
		},
		editFlowUrl() {
			if (this.taskInfo.projectId && this.taskInfo.flowId) {
				return this[editFlowLink.fullPath](this.taskInfo.projectId, this.taskInfo.flowId);
			}
			return undefined;
		},
		toInputLogs() {
			return { name: 'InterfacesLogs', params: { taskLogId: this.taskInfo.id } };
		},
		isDataExpired() {
			return Boolean(this.taskInfo.expired);
		},
	},
};
</script>

<style scoped lang="scss">
.task-log-info-details {
	color: #292829;
	font-size: 12px;
	font-weight: 400;

	.task-id {
		max-width: 25%;
		color: #bcbcbc;
		font-size: 10px;
	}

	.task-title {
		font-size: 20px;
		color: #3e495a;
		font-weight: 400;
		line-height: 24px;
	}
	.meta-info {
		color: var(--subtle-font-color);
	}
	.emphasize {
		margin: 0 px 0 0;
		color: var(--primary-font-color);
	}

	.expired-indicator {
		width: 80px;
		height: 22px;
		border-radius: 4px;
		border: 1px solid transparent;
		box-sizing: border-box;
		background: transparent;
		transition: all 0.2s 2s;
		line-height: 19px;
		text-align: center;
		font-size: 11px;
		text-transform: capitalize;
		background: mediumorchid;
		color: lavender;
	}
}
</style>
